import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { Button } from 'src/components/shared/Button'
import type { BeneficialOwnerFormValues } from 'src/interfaces/bankOnboarding'
import { maskIdentifier } from 'src/utils/paymentsOps/bankOnboardingForm'

interface Props {
  owner: BeneficialOwnerFormValues
  index: number
  onEdit(index: number): void
  onRemove(index: number): void
}

const BeneficialOwnerCardComponent = ({ owner, index, onEdit, onRemove }: Props) => {
  return (
    <div
      css={tw`flex flex-row items-center justify-between gap-4 rounded-lg border border-solid border-shades-100 p-3`}
    >
      <div css={tw`flex min-w-0 flex-col`}>
        <Typography variant="h6">
          {owner.firstName} {owner.lastName} · {owner.ownershipPercentage}%
        </Typography>
        <Typography variant="body2" css={tw`text-xs text-shades-500`}>
          {owner.identificationType || 'ID'} {maskIdentifier(owner.identificationNumber)} ·{' '}
          {owner.city}, {owner.state}
        </Typography>
      </div>
      <div css={tw`flex shrink-0 flex-row gap-2`}>
        <Button
          size="small"
          color="white"
          onClick={() => {
            onEdit(index)
          }}
        >
          Edit
        </Button>
        <Button
          size="small"
          color="grey"
          onClick={() => {
            onRemove(index)
          }}
        >
          Remove
        </Button>
      </div>
    </div>
  )
}

export const BeneficialOwnerCard = memo(BeneficialOwnerCardComponent)
